import React from 'react';
import cn from 'classnames';
// Styles
import './style.scss';
import { theme } from 'src/theme';

if (theme.mode === 'dark') {
  import(/* webpackChunkName: "dark" */ './style.scss?dark');
}

const Card = ({
  children, fluid, vertical, title, className,
}) => {
  const cardClassName = cn({
    card: !fluid,
    'card-fluid': fluid,
    'vertical-card-content': vertical,
    [className]: !!className,
  });

  return (
    <section className={cardClassName}>
      {title && <legend className='card-title'>{title}</legend>}
      <div className='card-content'>
        {children}
      </div>
    </section>
  );
};

export default Card;
